export const FIELDS_PAGE_ERROR = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión',
  },
  {
    name: 'clientName',
    inputAdornment: '',
    label: 'Nombre completo',
    textArea: '',
    disabled: false,
    required: true,
  },
  {
    name: 'phone',
    inputAdornment: '',
    label: 'Teléfono',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'email',
    inputAdornment: '',
    label: 'Correo actual',
    textArea: '',
    disabled: false,
    required: true,
  },
  {
    name: 'comment',
    inputAdornment: '',
    label: 'Escribir comentario',
    textArea: '',
    disabled: false,
    required: true,
    multiline: true,
    rows: 4,
  },
];
